import React from "react";
import { useAuth } from "../contexts/AuthContext";

import noUser from '../assets/images/no-user.png';

export default function UserSettings({ open }) {
    const { currentUser, signOut, signIn } = useAuth();

	return (
		<div className={`user ${open ? "open" : null}`}>
			{currentUser ? (
				<>
					<div className="user-image">
						<img
							src={currentUser.photoURL}
							alt={`Foto de perfil de ${currentUser.email}`}
						/>
					</div>
					<p className="user-name">{currentUser.displayName}</p>
					<p className="user-email">{currentUser.email}</p>
					<div className="user-actions">
						<button onClick={signOut} className="danger-button">
							Cerrar sesión
						</button>
					</div>
				</>
			) : (
				<>
                <div className="user-image">
						<img
							src={noUser}
							alt="Sin usuario"
						/>
					</div>
					<p className="user-name">No has iniciado sesión</p>
					<p className="user-email">No hay usuario</p>
					<div className="user-actions">
						<button onClick={signIn} className="action-button">
							Iniciar sesión
						</button>
					</div>
                </>
			)}
		</div>
	);
}
